import SiafLiteApiRepository from "../../external/siafLiteApi";

class MdfePedagioService {
  constructor() {
    this.urlBase = "/faturamento/mdfe-pedagio";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  cadastrar(data) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(data);
  }
}

export default MdfePedagioService;
